import { Control } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { Select, SelectAction, SelectContent, SelectGroup, SelectItem, SelectValue } from "keep-react";
import { FormField } from "../FormField";
import { RegisterFormData } from "../schema";

interface SelectFieldProps {
  control: Control<RegisterFormData>;
}

export const SelectField = ({ control }: SelectFieldProps) => {
  const { t } = useTranslation();

  return (
    <FormField
      name="salutation"
      control={control}
      label={
        <>
          {t("register.labels.salutation")}
          <span style={{ color: "red" }}>*</span>
        </>
      }
      placeholder={t("register.placeholders.salutation")}
      renderInput={(field, error) => (
        <Select
          onValueChange={(value) => {
            field.onChange(value);
            setTimeout(() => field.onBlur(), 100);
          }}
          value={field.value as string}
        >
          <SelectAction>
            <SelectValue
              placeholder={t("register.placeholders.salutation")}
              className={error ? "text-red-500" : ""}
            />
          </SelectAction>
          <SelectContent>
            <SelectGroup>
              <SelectItem value={t("register.salutations.mr")}>
                {t("register.salutations.mr")}
              </SelectItem>
              <SelectItem value={t("register.salutations.mrs")}>
                {t("register.salutations.mrs")}
              </SelectItem>
            </SelectGroup>
          </SelectContent>
        </Select>
      )}
    />
  );
};